/**
 * works
 */
'use strict';
import AppWorks from '@/_modules/app_works';

document.addEventListener('DOMContentLoaded', () => {
  new AppWorks();
}, false);

window.addEventListener('load', () => {

}, false);

window.addEventListener('unload', () => {}, false);

window.addEventListener('pageshow', function(event){
  if (event.persisted) {
    window.location.reload();
  }
});
